import RewardsSdkReadySdkEvent from "@modules/sdk/common_sdk/events/RewardsSdkReadySdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import SdkMethodsCollector from "@modules/sdk/methods/SdkMethodsCollector";
import Sdk from "@modules/sdk/Sdk";
import { SdkRegisteredModuleInterface } from "@modules/sdk/SdkRegisteredModuleInterface";

import RewardsSdkEvents from "./RewardsSdkEvents";
import RewardsSdkMethods from "./RewardsSdkMethods";

class RewardsSdk implements SdkRegisteredModuleInterface {
    public readonly events: RewardsSdkEvents;

    public readonly methods: RewardsSdkMethods;

    constructor(private readonly _collector: SdkMethodsCollector) {
        this.events = new RewardsSdkEvents();
        this.methods = new RewardsSdkMethods(this._collector);
    }

    public register(sdk: Sdk & { rewards?: RewardsSdk }) {
        sdk.rewards = this;

        // TODO: Delete deprecated code and its dependencies later if nobody uses it

        /** @deprecated Use `runIfModuleReady` method instead */
        document.dispatchEvent(new Event("gwRewardsSdkReady"));

        /** @deprecated Use `runIfModuleReady` method instead */
        dispatchSdkEvent(new RewardsSdkReadySdkEvent());
    }
}

export default RewardsSdk;
